import { filterModeLabels } from "../models/allergens"
import { AsOfNote } from "./StaleBanner"
import "./AllergenFilter.css"

export default function AllergenFilter({
  filters,
  selectedIds,
  showAllergens,
  onToggle,
  onModeChange
}) {
  const modeLabels = filterModeLabels(selectedIds)

  return (
    <div className="allergen">
      <div className="allergen__strip scroll-x">
        <div className="allergen__track">
          {filters.map((item) => {
            const isSelected = selectedIds.includes(item.id)
            return (
              <button
                key={item.id}
                type="button"
                className={`allergen-chip${isSelected ? " allergen-chip--selected" : ""}`}
                aria-pressed={isSelected}
                onClick={() => onToggle(item.id)}
              >
                <span className="allergen-chip__disc">
                  <img src={`/img/allergen-${item.icon}.png`} alt="" aria-hidden="true" />
                </span>
                <span className="allergen-chip__label t-p10">{item.title}</span>
              </button>
            )
          })}
        </div>
      </div>

      <AsOfNote className="allergen__as-of" />

      {selectedIds.length > 0 && (
        <div className="allergen__mode">
          <ModeRadio
            label={modeLabels.including}
            isSelected={showAllergens}
            onSelect={() => onModeChange(true)}
          />
          <ModeRadio
            label={modeLabels.excluding}
            isSelected={!showAllergens}
            onSelect={() => onModeChange(false)}
          />
        </div>
      )}
    </div>
  )
}

function ModeRadio({ label, isSelected, onSelect }) {
  return (
    <button
      type="button"
      className="allergen-mode"
      role="radio"
      aria-checked={isSelected}
      onClick={onSelect}
    >
      <span className={`allergen-mode__dot${isSelected ? " allergen-mode__dot--on" : ""}`} />
      <span className="t-p14">{label}</span>
    </button>
  )
}
